import React, { useState, useRef } from 'react';
import './Events.css';

const Events = () => {
  const [activeTab, setActiveTab] = useState('past');
  const videoRefs = useRef({});

  const handleVideoPlay = (videoId) => {
    Object.keys(videoRefs.current).forEach(id => {
      if (id !== videoId && videoRefs.current[id]) {
        videoRefs.current[id].pause();
      }
    });
  };

  const upcomingEvents = [
    {
      id: 1,
      title: "Annual Gadaa Meeting 2026",
      date: "August 20, 2026",
      time: "10:00 AM - 6:00 PM",
      location: "London Community Center",
      description: "Join us for our annual community meeting featuring traditional Gadaa democratic processes, community discussions, cultural presentations, and collective decision-making. This important gathering brings together the entire Oromo community in the UK.",
      image: "/Images/together.jpeg",
      category: "Meeting"
    },
    {
      id: 2,
      title: "Oromo Language Workshop",
      date: "September 15, 2026",
      time: "2:00 PM - 5:00 PM",
      location: "Birmingham Cultural Center",
      description: "Interactive workshop for learning Afaan Oromoo (Oromo language) for beginners and intermediate learners. Includes cultural context and practical conversation practice.",
      image: "/Images/image_3.jpeg",
      category: "Education"
    },
    {
      id: 3,
      title: "Community Assembly (Gumii)",
      date: "October 10, 2026",
      time: "6:00 PM - 9:00 PM",
      location: "Manchester Meeting Hall",
      description: "Monthly community meeting following traditional Gadaa democratic principles. Discussion of community matters, upcoming events, and collective decision-making.",
      image: "/Images/hand.jpeg",
      category: "Community"
    }
  ];

  const pastEvents = [
    {
      id: 5,
      title: "Annual Gadaa Meeting 2025",
      date: "August 20, 2025",
      time: "10:00 AM - 6:00 PM",
      location: "London Community Center",
      description: "Our annual community meeting featured traditional Gadaa democratic processes, community discussions, cultural presentations, and collective decision-making. This important gathering brought together the entire Oromo community in the UK.",
      image: "/Images/walgeeti_1.png",
      category: "Meeting"
    },
    {
      id: 6,
      title: "New Year Celebration (Irreecha)",
      date: "January 1, 2025",
      time: "12:00 PM - 6:00 PM",
      location: "Hyde Park, London",
      description: "Traditional Oromo New Year celebration with thanksgiving ceremonies, cultural performances, and community gathering.",
      image: "/Images/hand.jpeg",
      category: "Festival"
    },
    {
      id: 7,
      title: "Elder Wisdom Sharing Session",
      date: "December 15, 2025",
      time: "3:00 PM - 6:00 PM",
      location: "Glasgow Community Center",
      description: "Special session where community elders shared traditional stories, wisdom, and cultural knowledge with younger generations.",
      image: "/Images/image_3.jpeg",
      category: "Cultural"
    },
    {
      id: 8,
      title: "Traditional Craft Workshop",
      date: "November 20, 2025",
      time: "10:00 AM - 4:00 PM",
      location: "Sheffield Arts Center",
      description: "Hands-on workshop teaching traditional Oromo crafts including weaving, pottery, and traditional jewelry making.",
      image: "/Images/image_4.jpeg",
      category: "Arts"
    }
  ];

  const currentEvents = activeTab === 'upcoming' ? upcomingEvents : pastEvents;

  return (
    <div className="events">
      <div className="container">
        {/* Hero Section */}
        <section className="events-hero">
          <h1>Community Events</h1>
          <p>Stay connected with our vibrant community through cultural celebrations, educational programs, and social gatherings</p>
        </section>

        {/* Event Tabs */}
        <section className="events-tabs">
          <div className="tab-buttons">
            <button 
              className={activeTab === 'upcoming' ? 'active' : ''}
              onClick={() => setActiveTab('upcoming')}
            >
              Upcoming Events
            </button>
            <button 
              className={activeTab === 'past' ? 'active' : ''}
              onClick={() => setActiveTab('past')}
            >
              Past Events
            </button>
          </div>
        </section>

        {/* Events Content */}
        <section className="events-content">
          <div className={`events-grid ${activeTab === 'past' ? 'past-events' : ''}`}>
            {currentEvents.map(event => (
              <div key={event.id} className="event-card">
                <div className="event-image">
                  <img src={event.image} alt={event.title} />
                  <div className="event-category">{event.category}</div>
                </div>
                <div className="event-details">
                  <h3>{event.title}</h3>
                  <div className="event-meta">
                    <div className="meta-item">
                      <strong>Date:</strong> {event.date}
                    </div>
                    <div className="meta-item">
                      <strong>Time:</strong> {event.time}
                    </div>
                    <div className="meta-item">
                      <strong>Location:</strong> {event.location}
                    </div>
                  </div>
                  <p className="event-description">{event.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Community Elder Videos - Only show for past events */}
        {activeTab === 'past' && (
          <section className="community-videos">
            <h2>Community Elder Speeches</h2>
            <p className="videos-intro">Watch our respected elders share their wisdom and insights about our community, traditions, and the importance of preserving our cultural heritage.</p>
            <div className="videos-grid">
              <div className="video-item">
                <div className="video-container">
                  <video 
                    ref={el => videoRefs.current['dida'] = el}
                    controls
                    onPlay={() => handleVideoPlay('dida')}
                  >
                    <source src="/videos/Dida Guracha.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="video-info">
                  <h3>Dida Guracha</h3>
                  <p>Elder Dida Guracha shares profound insights about the traditional Gadaa system and its relevance in modern times. He speaks about the importance of maintaining our democratic traditions and passing them on to future generations.</p>
                </div>
              </div>
              
              <div className="video-item">
                <div className="video-container">
                  <video 
                    ref={el => videoRefs.current['galgal'] = el}
                    controls
                    onPlay={() => handleVideoPlay('galgal')}
                  >
                    <source src="/videos/Galgal_Boru.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="video-info">
                  <h3>Galgal Boru</h3>
                  <p>Elder Galgal Boru discusses the significance of community unity and the role of elders in guiding the younger generation. His speech emphasizes the values of respect, wisdom, and collective responsibility.</p>
                </div>
              </div>
              
              <div className="video-item">
                <div className="video-container">
                  <video 
                    ref={el => videoRefs.current['garbole'] = el}
                    controls
                    onPlay={() => handleVideoPlay('garbole')}
                  >
                    <source src="/videos/Garbole.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="video-info">
                  <h3>Garbole</h3>
                  <p>Elder Garbole reflects on the journey of the Oromo community in the UK and the importance of preserving our cultural identity while adapting to new environments. His words inspire unity and cultural pride.</p>
                </div>
              </div>
              
              <div className="video-item">
                <div className="video-container">
                  <video 
                    ref={el => videoRefs.current['hassan'] = el}
                    controls
                    onPlay={() => handleVideoPlay('hassan')}
                  >
                    <source src="/videos/HassanAbdullah.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="video-info">
                  <h3>Hassan Abdullah</h3>
                  <p>Elder Hassan Abdullah speaks about the challenges and opportunities facing our community. He emphasizes the importance of education, cultural preservation, and building bridges between generations.</p>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Event Categories */}
        <section className="event-categories">
          <h2>Event Categories</h2>
          <div className="categories-grid">
            <div className="category-item">
              <h3>Cultural Festivals</h3>
              <p>Traditional celebrations including Irreecha, Gadaa ceremonies, and seasonal festivals</p>
            </div>
            <div className="category-item">
              <h3>Educational Programs</h3>
              <p>Language classes, cultural workshops, and knowledge sharing sessions</p>
            </div>
            <div className="category-item">
              <h3>Community Meetings</h3>
              <p>Annual Gadaa meetings, democratic assemblies, decision-making sessions, and community discussions</p>
            </div>
            <div className="category-item">
              <h3>Youth Activities</h3>
              <p>Mentorship programs and youth-focused events</p>
            </div>
            <div className="category-item">
              <h3>Arts & Crafts</h3>
              <p>Traditional craft workshops, music sessions, and artistic expressions</p>
            </div>
            <div className="category-item">
              <h3>Social Gatherings</h3>
              <p>Community meals, networking events, and informal social activities</p>
            </div>
          </div>
        </section>

        {/* Event Information */}
        <section className="event-info">
          <div className="info-card">
            <h2>Stay Updated</h2>
            <p>Don't miss out on our community events! Contact us to join our mailing list and receive regular updates about upcoming activities.</p>
            <div className="contact-details">
              <p><strong>Email:</strong> events@gadaa-uk.org</p>
              <p><strong>Phone:</strong> +44 (0) 20 1234 5678</p>
              <p><strong>Follow us on social media for real-time updates</strong></p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Events;
